import './index.less';
import React from 'react';
import classnames from 'classnames';
import EmailInput from 'ck-core-client/source/ui/form/EmailInput';
import RoundButton from 'ck-core-client/source/ui/RoundButton';
import BackgroundGraphic from 'ck-core-client/source/ui/components/BackgroundGraphic/BackgroundGraphic.jsx';
import Modal from '../';
import { addLeadEmail } from 'ck-core-client/source/functions/addLeadEmail';
import lang from './lang';
import { Trackers } from 'ck-core-client/source/trackers/Trackers';

interface Props {
	trackers: Trackers;
	open: boolean;
	onClose: () => void;
}

interface State {
	shake: boolean;
	open: boolean;
	collapsed: boolean;
	sent: boolean;
	inputError?: any;
	inputValue: string;
}

export class EmailCaptureModal extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			shake: false,
			open: false,
			collapsed: false,
			sent: false,
			inputError: null,
			inputValue: ''
		};
	}

	async emitEmail() {
		const { inputValue } = this.state;

		this.setState({
			shake: false
		});

		if (inputValue) {
			try {
				await addLeadEmail(inputValue, this.props.trackers, CK.fn.inTest('EmailCaptureIncentive'));

				this.setState({
					sent: true
				});

				setTimeout(
					() =>
						this.setState({
							open: false
						}),
					4000
				);
			} catch (e) {
				CK.logger.error(e);

				this.setState({
					shake: true
				});
			}
		}
	}

	render() {
		const { open, onClose } = this.props;
		const { inputError, inputValue, sent, shake } = this.state;

		const inEmailTest = CK.fn.inTest('EmailCaptureIncentive');

		const messageLang = inEmailTest
			? 'Sign up to learn more about Code Kingdoms and get 10% off!'
			: 'Subscribe to hear our latest news and gain access to special promotions';

		const titleLang = inEmailTest ? 'Save 10%!' : 'Can we keep in touch?';

		const postSignupLang = inEmailTest
			? `Thanks for signing up! Check your inbox to redeem your discount.`
			: lang.THANKS;

		return open ? (
			<div className="EmailCaptureModal__container">
				<Modal colour={'blue'} onClose={onClose} overflow={'hidden'}>
					<div className="EmailCaptureModal__wrapper">
						<BackgroundGraphic
							name="green-guy-in-cloud"
							right="-4rem"
							top="75%"
							styles={{ height: '22.5rem', width: '22.5rem', transform: 'rotateY(180deg)' }}
						/>
						<BackgroundGraphic name="blue-cloud-email-modal" left="-6rem" top="0rem" />
						<div className={`EmailCaptureModal ${!open ? 'EmailCaptureModal--collapsed' : null}`}>
							<div
								className={classnames(
									'EmailCaptureModal__content',
									!open || sent ? 'EmailCaptureModal__content--collapsed' : null
								)}
							>
								<div className="EmailCaptureModal__cell">
									<div className="EmailCaptureModal__title">{titleLang}</div>
									<div className="EmailCaptureModal__subtitle">{messageLang}</div>
								</div>
								<div className="EmailCaptureModal__cell">
									<div
										className={`EmailCaptureModal__input ${
											shake ? 'EmailCaptureModal__shake' : null
											}`}
									>
										<EmailInput
											noLabel
											name="email"
											valid={!inputError}
											error={inputError}
											value={inputValue}
											optional={true}
											onChange={inputValue => this.setState({ inputValue })}
										/>
									</div>
								</div>
								<div className="EmailCaptureModal__cell">
									<RoundButton
										text="Sign me up"
										size="medium"
										colour="red"
										handleClick={() => this.emitEmail()}
									/>
								</div>
							</div>
							{sent ? (
								<div className="EmailCaptureModal__content">
									<div className="EmailCaptureModal__sent">{postSignupLang}</div>
								</div>
							) : null}
						</div>
					</div>
				</Modal>
			</div>
		) : null;
	}
}
